import React from "react";
import PropTypes from "prop-types";

function Hidden({ methods, name, value }) {
  const { register } = methods;
  return <input {...register(name)} type="hidden" value={value} />;
}

Hidden.defaultProps = {
  name: "hidden",
  value: "hidden_value",
};

Hidden.propTypes = {
  /**
   * methods du useForm()
   */
  methods: PropTypes.instanceOf(Object),
  /**
   * Name du tag HTML input
   */
  name: PropTypes.string,
  /**
   * Name du tag HTML input
   */
  value: PropTypes.string,
};

export default Hidden;
